import React from "react";
import Directive from "./directive/Directive";
import Question from "./question/Question";

const View = ( props ) => {

  const {
    children,
    ...PROPS
  } = props;

  return (
    <div className="leaningCont" onClick={ props.onSelect }>
      <div className="learning-wrap">
        <Directive { ...PROPS } />
        <Question { ...PROPS } />
      </div>
    </div>
  );

};

export default View;
